<script>
</script>

<div class="slide">
    <slot></slot>
</div>

<style>
    .slide {
        flex: 1;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
    }
</style>